import '.b9{font-family:FunnelDisplay;}.ssr-plugin'
import '.fe{font-weight:700;}.ssr-plugin'
import '.ek{margin-top:0px;}.ssr-plugin'
import '.f5{margin-bottom:1.5rem;}.ssr-plugin'
import useMediaQuery from '@app/util/useMediaQuery'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

export interface QuoteProps extends PropsWithChildren {
  style?: Style
}

export const Quote = ({ children, style }: QuoteProps) => {
  const isMobile = useMediaQuery()

  return (
    <styled.blockquote className="b9 fe ek f5"
      style={{
        fontSize: isMobile ? '2rem' : '3rem',
        lineHeight: isMobile ? '130%' : '100%',
        ...style,
      }}
    >
      “{children}”
    </styled.blockquote>
  )
}
